export default function sendReady(){
    window.dispatchEvent(new Event("fast-upsell-crossell-ready"))
    window.dispatchEvent(new Event("fast-upsell-cross-sell-ready"))
}